
import { defineComponent, PropType, ref, computed } from "vue";
import TUIViewer from "../../components/application/TUIViewer.vue";
import StarInput from "../../components/application/inputs/StarInput.vue";
import { QuestionForm } from "../../../../domain/entities/search-form/question_form";

export default defineComponent({
  name: "QuestionFormStar",
  components: { StarInput, TUIViewer },
  props: {
    question: {
      type: Object as PropType<{ question: QuestionForm }>,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const stars = ref(props.question.question.stars || 0);

    const maxStars = computed(
      () => props.question.question.evaluation?.maxStars ?? 5
    );

    const starValues = computed(() =>
      Array.from({ length: maxStars.value }, (_, i) => i + 1)
    );

    function getStars() {
      return stars.value;
    }

    return {
      stars,
      starValues,
      maxStars,
      getStars
    };
  }
});
